import React from "react";
import { Field, Operation } from "typegraph";

import CountResult from "common/entities/CountResult";
import NonIdealState from "common/fragments/NonIdealState";
import { BlockView } from "common/views/block/BlockView.view";
import { CardView } from "common/views/card/Card.view";
import PagingView from "common/views/paging/Paging.view";
import { RowsView } from "common/views/rows/Rows.view";
import Query from "core/api/QueryComponent";
import { FragmentLayout } from "core/components/FragmentLayout";
import { IPanelProps, Panel } from "core/decorators/Panel";
import StringUtil from "core/util/StringUtil";
import ProgramListConfig from "./config/ProgramListPanelConfig";
import Badge from "./entities/Badge";
import Program from "./entities/Program";
import * as badgeFragments from "./fragments/badge/displayFragments";
import * as programDisplayFragments from "./fragments/program/displayFragments";
import labelProvider from "./Program.labels";

const { Labels } = labelProvider;

function mapParams(data) {
	return {params: {
		pageNumber: data.pageNumber || 0,
		pageSize: data.pageSize || 5
	}};
}

@Operation({type: "query"})
class ProgramListQuery {

	@Field({
		entity: Program,
		params: mapParams,
		aliasFor: "programs"
	})
	public programs: Program[] | null;

	@Field({
		entity: CountResult,
		params: mapParams,
		aliasFor: "programCount"
	})
	public count: CountResult;

}

@Panel({
	id: "program-list",
	configClass: ProgramListConfig,
	labelProvider,
	pageParams: true
})
export default class ProgramListPanel extends React.Component<IPanelProps<ProgramListConfig>> {

	public render() {
		const { config, locale, pageParams } = this.props;

		const params: any = {
			loadBadges: true,
			loadTracks: false,
			loadCourses: false,
			loadTests: false
		};

		if (config.enableLanguageSupport) {
			params.language = locale;
		}

		params['pageNumber'] = StringUtil.toInteger(pageParams['pageNumber'], 0);
		params['pageSize'] = StringUtil.toInteger(pageParams['pageSize'], config.pageSize || 5);

		return (
			<Query.Root entity={ProgramListQuery} args={params}>
				{(args) => {
					if (!args.loading && !args.data) {
						return (
							<NonIdealState
								title={<Labels.NotFoundTitle />}
								description={<Labels.NotFoundDescription />}
							/>
						);
					}

					return (
						<React.Fragment>
							<RowsView viewKey="rows">
								{args.data && args.data.programs.map(this.renderProgram) || null}
							</RowsView>
							<BlockView viewKey="paging.block">
								<PagingView
									viewKey="paging"
									pageSize={params['pageSize']}
									pageNumber={params['pageNumber']}
									total={args.data && args.data.count.count}
									setPageNumber={(pageNumber) => this.props.actions.pushPageParam('pageNumber', pageNumber.toString())}
								/>
							</BlockView>
						</React.Fragment>
					);
				}}
			</Query.Root>
		);
	}

	private renderProgram = (program: Program) => {
		const { config } = this.props;

		return (
			<CardView key={program.id} viewKey="card">
				<FragmentLayout
					layout={config.programLayout}
					fragments={programDisplayFragments}
					props={{program, renderBadges: this.renderBadges}}
				/>
			</CardView>
		);
	}

	private renderBadges = (badges: Badge[]) => {
		const { config } = this.props;

		return (
			<div>
				{
					badges.map((badge) => (
						<FragmentLayout
							key={badge.id}
							layout={config.badgeLayout}
							fragments={badgeFragments}
							props={{badge}}
						/>
					))
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/catalog/ProgramList.panel.tsx